'use strict'

module.exports = {
  NODE_ENV: 'development',
  ENV_CONFIG: 'dev',
  productionSourceMap:'false',
  //测试配置
  //BASE_API: 'https://118.89.33.52:8081/dagReservation/',
  //正式环境
  BASE_API: 'https://www.da.gd.gov.cn/dagReservation/'
  //本地配置
  // BASE_API: 'http://127.0.0.1:8081/dagReservation'
   //BASE_API: 'http://192.168.200.11:8081/dagReservation'
}